module.exports = __webpack_public_path__ + "static/php.svg-fd7e1ee1d6381f631115d63679670c1b.png";